import * as types from 'generated/graphql';

import { ITypeSpecificPolicy } from './shared';
import { dateTimeFieldPolicy } from './fieldPolicies';



export const Inspection: ITypeSpecificPolicy<types.Inspection> = {
  fields: {
    createdAt: dateTimeFieldPolicy(),
    dateInspected: dateTimeFieldPolicy()
  }
};
